import React from "react";
import CustomButton from "../ui/Button";
import { useTranslation } from "react-i18next";


const KeyFocus = () => {
  const descriptions = [
    "autonomous_systems_development",
    "ai_and_machine_learning_for_failures",
    "eco_friendly_solutions",
    "virtual_models_simulation",
    "enhanced_decision_making",
    "proximity_detection_and_collision_avoidance",
  ];
  const { t,i18n } = useTranslation("research"); // Hook to use translations
  const isRussian = i18n.language === "ru"; // Check if the language is Russian


  return (
    <div>
      <div
        className="relative min-h-[984px] sm:h-[100vh] lg:min-h-[684px] md:h-[592px] bg-cover bg-center bg-no-repeat mt-10"
        style={{ backgroundImage: "url('/assets/advantage.png')" }}
      >
        <div className="absolute inset-0 flex flex-col items-center justify-center text-color-3 text-center px-4 md:px-8 lg:px-16">
          <div>
            <h1 className="web-heading-section mb-4 md:mb-6 text-white md:text-left sm:mx-12">
              Key focus areas
            </h1>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full max-w-6xl">
              {[...Array(6)].map((_, index) => (
                <div
                  key={index}
                  className="rounded-lg shadow-md p-4 md:p-12 bg-white bg-opacity-5 backdrop-blur-md h-auto flex items-center text-start justify-center"
                >
                  <p className="text-sm md:text-base text-gray-200 px-2 py-2">
                    {t(descriptions[index])}

                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="p-5 sm:p-[100px] flex flex-col justify-center items-center gap-5 text-center ellipsebg">

        <div className='max-w-[818px] flex flex-col justify-center items-center text-center gap-5'>
          <h1 className="web-heading-section px-12">
            {t("join_team")}
          </h1>
          <p className={`body-large-30 text-[#F0F0F0B2] ${isRussian ? 'lang-ru-contact-desc' : ''}`}>

            {t("join_team_description")}
          </p>
          <CustomButton>{t("contact_rd_team")}</CustomButton>

          <h2 className="title-xl-2">{t("spontaneous_applications")}</h2>

          <p className={`body-large-30 text-[#F0F0F0B2] ${isRussian ? 'lang-ru-contact-desc' : ''}`}>

            {t("spontaneous_applications_description")}
          </p>

        </div>

      </div>
    </div>
  );
};

export default KeyFocus;
